import css from 'styled-jsx/css';

const styles = css.global`#financiamento-imobiliario {
    background: #F0F0F0;
    min-height: 801px;
    padding-bottom: 80px;
}

#financiamento-imobiliario picture {
    position: relative;
    display: block;
    overflow: hidden;
}

#financiamento-imobiliario .imobiliario-titulo {
    color: #222;
    font-family: "SantanderHeadline";
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 60px;
    margin: 48px 0 0;
}

#financiamento-imobiliario .imobiliario-paragrafo {
    color: var(--black-444444, #444);
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    margin: 16px 0;
}

#financiamento-imobiliario .imobiliario-paragrafo b {
    font-weight: 600;
}

#financiamento-imobiliario .imobiliario-btn {
    width: 100%;
    max-width: 272px;
    height: 48px;
    margin: auto;
}

#financiamento-imobiliario .imobiliario-banner {
    width: 100%;
    height: 361px;
    object-fit: cover;
}

#financiamento-imobiliario .is-desk {
    display: none;
}

#financiamento-imobiliario .fade-banner {
    opacity: 0.25;
    background: var(--Red-Red-Boston-01, #C00);
    mix-blend-mode: multiply;
    width: 100%;
    height: 361px;
    position: absolute;
    top: 0;
}

#financiamento-imobiliario .fade-banner-gradiente {
    background: linear-gradient(90deg, #900 0%, rgba(153, 0, 0, 0.73) 10.94%, rgba(153, 0, 0, 0.00) 56.77%);
    mix-blend-mode: plus-darker;
    width: 3506px;
    height: 361px;
    position: absolute;
    top: 0;
    left: -900px;
}

@media(min-width: 992px) {
    #financiamento-imobiliario .is-desk {
        display: block;
        border-radius: 4px;
        height: 361px;
    }

    #financiamento-imobiliario .is-mob {
        display: none;
    }

    #financiamento-imobiliario .imobiliario-banner,
    #financiamento-imobiliario .fade-banner,
    #financiamento-imobiliario .fade-banner-gradiente
     {
        border-radius: 4px;
    }

    #financiamento-imobiliario .fade-banner-gradiente {
        left: -400px;
    }
    #financiamento-imobiliario {
        padding: 64px 0 48px;
        min-height: 745px;
    }

    #financiamento-imobiliario .imobiliario-btn  {
        max-width: 272px;
        margin: 48px auto 0;
    }
}

@media(min-width: 1280px) {
    #financiamento-imobiliario .ctn-home-24 {
        max-width: 1280px;
    }
}`;

export default styles;